import React, {useEffect, useRef, useState} from 'react';
import cl from "./FormInput.module.css";
import {FormHelperText, TextField} from "@mui/material";
import FormControlCaption from "./FormControlCaption";
import "./helperText.css";

const FormInput = ({label, initValue, widthLimit, controlRef, placeholder, tipText, readOnly, validateTextFunc, infoText}) => {

    const inputRef = useRef(null);
    const [errorMessage, setErrorMessage] = useState("")

    const correctedWidthLimit = widthLimit === undefined ? 10000 : widthLimit;

    useEffect(() => {
        if (controlRef) {
            controlRef.current = {
                getText: getText,
                validateNotEmpty: validateNotEmpty,
                validateLength: validateLength,
                validateText: validateText,
                setErrorMessage: setErrorMessage,
            };
        }
    })

    function getText() {
        return inputRef.current.value.trim();
    }

    function validateNotEmpty(errorMessage) {
        if (getText().length > 0)
            return true;
        setErrorMessage(errorMessage);
        return false;
    }

    function validateLength(maxLength, errorMessage = undefined) {
        const textLength = getText().length;
        if (textLength <= maxLength)
            return true;
        setErrorMessage(errorMessage ?? `Слишком длинная строка! (нужно укоротить на ${textLength - maxLength} символ(ов))`);
        return false;
    }

    function validateText(errorMessage) {
        if (!validateTextFunc || validateTextFunc(getText()))
            return true;
        setErrorMessage(errorMessage);
        return false;
    }

    return (
        <div className={cl.main}>
            <FormControlCaption
                text={label}
                tipText={tipText}
            />
            <TextField
                type="text"
                variant="outlined"
                hiddenLabel
                inputRef={inputRef}
                defaultValue={initValue}
                placeholder={placeholder}
                error={errorMessage !== ""}
                helperText={errorMessage}
                /*disabled={true}*/
                /*label={"test"}*/
                sx={{width: `min(${correctedWidthLimit}px, 100%)`}}
                slotProps={{
                    /*htmlInput: {
                        sx: { backgroundColor: "white", borderRadius: "4px" }
                    },*/
                    input: {
                        readOnly: readOnly,
                        sx: {
                            backgroundColor: readOnly ? "#ffff0018" : "white",
                            borderRadius: "4px",
                            /*pointerEvents: readOnly ? "none" : "auto",*/
                        }
                    },
                    formHelperText: {
                        sx: {width: "max-content", maxWidth: "350px"}
                    }
                }}
                onChange={() => {
                    if (errorMessage)
                        setErrorMessage("")
                }}
            />
            {infoText && <FormHelperText sx={{marginLeft:"14px"}} className="helperText">
                {infoText}
            </FormHelperText>}
        </div>
    );
};

export default FormInput;